/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './style.scss';

interface IProps {
    icon?: React.ReactNode;
    size?: number;
    className?: string;
    onClick?: (e: any) => void;
}

const IconWrap: React.FC<IProps> = ({ icon, className, size, onClick }) => {
    return (
        <div className={`${className ? className : ''} icon__wrap`} style={{ fontSize: size }} onClick={onClick}>
            {icon}
        </div>
    );
};

export default React.memo(IconWrap);
